import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { useFeatureDisclaimers } from 'hooks/use-feature-disclaimers';
import { spacing } from 'styles/constants';

const Disclaimer = () => {
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { copyrightAndTrademark, reservedRights } = featureDisclaimers || {};

  if (!copyrightAndTrademark?.locale || !reservedRights?.locale) {
    return null;
  }

  return (
    <Box style={styles.wrapper} testID="branding-disclaimer">
      <Typography fontSize="2xs">
        {copyrightAndTrademark?.locale}
        {reservedRights?.locale}
      </Typography>
    </Box>
  );
};

export default Disclaimer;

const styles = StyleSheet.create({
  wrapper: {
    borderTopColor: 'black',
    borderTopWidth: 1,
    paddingVertical: spacing.$4,
  },
});
